import {combineReducers} from 'redux'
import auth from './auth'
import allocations from './allocations'
import luckyAllocations from './luckyAllocations'
import religions from './religions'
import states from './states'
import politicalAffiliations from './politicalAffiliations'
import ethnicities from './ethnicities'
import settings from './settings'
import stats from './stats'
import userData from './userData'
import { reducer as reduxFormReducer } from 'redux-form'

const rootReducer = combineReducers({
	auth,
	allocations,
	luckyAllocations,
	religions,
	states,
	politicalAffiliations,
	ethnicities,
	settings,
	stats,
	userData,
	form: reduxFormReducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/rootReducer.js